<template>
  <div>
    <div class="f-inline-group">
      <legend
        :class="{ 'f-field__label--required' : isRequired }"
        class="f-field__label"
      >
        {{ $t(`fields.record.${fieldName}.label`) }}
      </legend>
      <div
        v-if="$te(`advancedsearch.fields.${fieldName}.description`)"
        class="f-field__tooltip"
      >
        <Tooltip>
          <p>
            {{ $t(`advancedsearch.fields.${fieldName}.description`) }}
          </p>
        </Tooltip>
      </div>
    </div>
    <div class="f-field">
      <div class="f-inline-group">
        <div class="f-field-advanced-search__controller-select">
          <select
            v-model="modelValue.option"
            class="f-field__input f-field__input--select"
            @change="validate(value)"
          >
            <option
              v-for="opt in ['more-recent', 'less-recent', 'between']"
              :key="fieldName + opt"
              :value="opt"
            >
              {{ $t(`advancedsearch.fields.date.options.${opt}`) }}
            </option>
          </select>
        </div>
        <div class="f-field--stack">
          <DateInput
            v-model="modelValue.value.start"
            :field-name="`record.${fieldName}`"
            :is-required="isRequired"
            :show-label="false"
            :error="errorFirst"
            @input="validate(value)"
          />
          <DateInput
            v-if="modelValue.option === 'between'"
            v-model="modelValue.value.end"
            :field-name="`record.${fieldName}`"
            :is-required="isRequired"
            :show-label="false"
            :error="errorSecond"
            @input="validate(modelValue)"
          />
        </div>
      </div>
    </div>
    <div
      :class="{'f-field--danger': errorAll !== null}"
    >
      <Transition name="validation-fade">
        <p
          v-if="errorAll !== null"
          class="f-field__validation"
        >
          {{ errorAll.message }}
        </p>
      </Transition>
    </div>
  </div>
</template>

<script>
import { MetadataUtils } from '@scholar/metadata-utils/main'
import DateInput from '#src/components/utils/fields/DateInput.vue'
import Tooltip from '#src/components/utils/Tooltip.vue'

export default {
  components: {
    DateInput,
    Tooltip
  },
  props: {
    modelValue: {
      type: Object,
      default: null
    },
    fieldName: {
      type: String,
      required: true
    },
    recordType: {
      type: String,
      required: true
    },
    validatorName: {
      type: String,
      default: undefined
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    hideTooltip: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  data() {
    return {
      validation: { status: true, first: { status: true }, second: { status: true } },
      validator: new MetadataUtils().validators.date
    }
  },
  computed: {
    errorFirst() {
      return this.validation.first.status
        ? null
        : { type: 'danger', message: this.$t(`forms.fields.errors.metadata-utils.${this.validation?.first.error}`) }
    },
    errorSecond() {
      return this.validation.second.status
        ? null
        : { type: 'danger', message: this.$t(`forms.fields.errors.metadata-utils.${this.validation?.second.error}`) }
    },
    errorAll() {
      // FIXME
      return this.validation.status
        ? null
        : { type: 'danger', message: this.$t('forms.fields.errors.fill.all') }
    }
  },
  created() {
    if (this.modelValue.value === null) {
      this.modelValue.value = { start: {}, end: {} }
    }
    if (this.modelValue.option === null) {
      this.modelValue.option = 'more-recent'
    }
  },
  methods: {
    isDateEmpty(date) {
      return Object.keys(date).length === 0
    },
    async validate(val) {
      this.validation = { status: true, first: { status: true }, second: { status: true } }
      if (!this.isDateEmpty(val.value.start)) {
        this.validation.first = this.validator(val.value.start)
      }
      if (val.option === 'between' && !this.isDateEmpty(val.value.end)) {
        this.validation.second = this.validator(val.value.end)
      }
      if (val.option === 'between' && !this.isDateEmpty(val.value.start) && this.validation.first.status && this.isDateEmpty(val.value.end)) {
        this.validation.status = false
      }
      this.modelValue.isValid = this.validation.first.status && this.validation.second.status && this.validation.status
      this.$emit('change', this.modelValue)
    }
  }
}
</script>
